



// import React, { useState, useEffect } from "react";
// import Button from "../../components/ui/Button";
// import StockHeader from "./StockHeader";
// import StockItems from "./StockItems";
// import api from "../../api/api";

// // --- Print Preview Modal ---
// const PrintPreview = ({ htmlContent, onClose }) => (
//   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
//     <div className="relative w-full max-w-sm p-4 bg-white rounded-lg shadow-2xl">
//       <h3 className="mb-2 text-lg font-semibold text-center">
//         Invoice Preview
//       </h3>
//       <div className="border border-gray-300">
//         <iframe
//           title="Print Preview"
//           srcDoc={htmlContent}
//           style={{ width: "100%", height: "60vh", border: "none" }}
//         />
//       </div>
//       <div className="flex justify-end gap-3 mt-4">
//         <Button
//           onClick={onClose}
//           className="px-4 py-2 text-white bg-red-500 rounded-lg shadow-sm hover:bg-red-600"
//         >
//           Close
//         </Button>
//         <Button
//           onClick={() => window.print()}
//           className="px-4 py-2 text-white bg-blue-600 rounded-lg shadow-sm hover:bg-blue-700"
//         >
//           Print
//         </Button>
//       </div>
//     </div>
//   </div>
// );

// const StockDetailsPage = ({ setView, context, refreshOrders, user }) => {
//   const [printContent, setPrintContent] = useState("");
//   const [isOrderHeaderOpen, setIsOrderHeaderOpen] = useState(false);
//   const [isOrderItemsOpen, setIsOrderItemsOpen] = useState(true);

//   const [orderDetails, setOrderDetails] = useState(context?.stock || {});
//   const [orderItems, setOrderItems] = useState(context?.items || []);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   // ✅ Fetch from API if no items in context
//   const refetchData = async () => {
//     try {
//       if (!context?.id) return;
//       const data = await api.getselectedStock(context.id);
//       setOrderDetails(data?.Table?.[0] || {});
//       setOrderItems(data?.Table1 || []);
//     } catch (err) {
//       console.error("Error fetching stock details:", err);
//       setError("Failed to fetch stock details.");
//     }
//   };

//   useEffect(() => {
//     if (!context?.items || context.items.length === 0) {
//       refetchData();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [context?.id]);

//   // Print handler
//   const handlePrintInvoice = () => {
//     const html = `
//       <h2>Invoice #${orderDetails.DocNo || context?.id}</h2>
//       <p>Customer: ${orderDetails.vname || orderDetails.Vname || ""}</p>
//       <p>Date: ${orderDetails.podate || orderDetails.StockDate || ""}</p>
//       <hr/>
//       <ul>
//         ${orderItems
//           .map(
//             (it) =>
//               `<li>${it.ItemNo} - ${it.Qty} x ${it.Rate} = ${(
//                 it.Qty * it.Rate
//               ).toFixed(2)}</li>`
//           )
//           .join("")}
//       </ul>
//     `;
//     setPrintContent(html);
//   };

//   // Accordion UI section
//   const AccordionSection = ({ title, isOpen, onToggle, children }) => (
//     <div className="border border-gray-200 rounded-lg overflow-hidden mb-4">
//       <div
//         className="flex items-center justify-between p-4 bg-gray-100 cursor-pointer hover:bg-gray-200"
//         onClick={onToggle}
//       >
//         <h2 className="text-lg font-medium text-gray-800">{title}</h2>
//         <span>{isOpen ? "▲" : "▼"}</span>
//       </div>
//       {isOpen && <div className="p-4 bg-white">{children}</div>}
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {printContent && (
//         <PrintPreview
//           htmlContent={printContent}
//           onClose={() => setPrintContent("")}
//         />
//       )}

//       {/* Header Bar */}
//       <div className="p-4 bg-white shadow">
//         <h1 className="mb-4 text-xl font-bold text-center text-gray-900">
//           {`Stock Details #${context?.id}`}
//         </h1>
//       </div>

//       {/* Error & Success Messages */}
//       {error && (
//         <div className="p-2 mx-auto my-2 text-red-700 bg-red-100 border border-red-300 rounded max-w-5xl">
//           {error}
//         </div>
//       )}
//       {success && (
//         <div className="p-2 mx-auto my-2 text-green-700 bg-green-100 border border-green-300 rounded max-w-5xl">
//           {success}
//         </div>
//       )}

//       <div className="flex justify-center mt-6">
//         <div className="w-full max-w-5xl p-4 sm:p-6 bg-white shadow-lg rounded-xl">
//           {/* Stock Header */}
//           <AccordionSection
//             title="Stock Information"
//             isOpen={isOrderHeaderOpen}
//             onToggle={() => setIsOrderHeaderOpen(!isOrderHeaderOpen)}
//           >
//             <StockHeader
//               orderDetails={orderDetails}
//               user={user}
//               setSuccess={setSuccess}
//               setError={setError}
//               setOrderDetails={setOrderDetails}
//             />
//           </AccordionSection>

//           {/* Stock Items */}
//           <AccordionSection
//             title="Stock Items"
//             isOpen={isOrderItemsOpen}
//             onToggle={() => setIsOrderItemsOpen(!isOrderItemsOpen)}
//           >
//             <StockItems
//               orderId={context?.id}
//               stockId={orderDetails?.Vid}
//               orderDate={orderDetails?.podate || orderDetails?.StockDate}
//               items={orderItems}
//               user={user}
//               setError={setError}
//               refetchData={refetchData}
//             />
//           </AccordionSection>

//           {/* Actions */}
//           <div className="flex justify-end gap-3 pt-4 mt-6 border-t">
//             <Button
//               onClick={() => {
//                 refreshOrders?.();
//                 setView("list");
//               }}
//               className="bg-pink-500 hover:bg-pink-600 px-4 py-2 text-white text-sm rounded"
//             >
//               Finish Order
//             </Button>
//             {/* Uncomment if you want Invoice Print */}
//             {/* <Button
//               onClick={handlePrintInvoice}
//               className="bg-green-500 hover:bg-green-600 px-4 py-2 text-white text-sm rounded"
//             >
//               Invoice
//             </Button> */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StockDetailsPage;




import React, { useState, useEffect } from "react";
import Button from "../../components/ui/Button";
import StockHeader from "./StockHeader";
import StockItems from "./StockItems";
import api from "../../api/api";

// --- Print Preview Modal ---
const PrintPreview = ({ htmlContent, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="relative w-full max-w-sm p-4 bg-white rounded-lg shadow-2xl">
      <h3 className="mb-2 text-lg font-semibold text-center">
        Invoice Preview
      </h3>
      <div className="border border-gray-300">
        <iframe
          title="Print Preview"
          srcDoc={htmlContent}
          style={{ width: "100%", height: "60vh", border: "none" }}
        />
      </div>
      <div className="flex justify-end gap-3 mt-4">
        <Button
          onClick={onClose}
          className="px-4 py-2 text-white bg-red-500 rounded-lg shadow-sm hover:bg-red-600"
        >
          Close
        </Button>
        <Button
          onClick={() => window.print()}
          className="px-4 py-2 text-white bg-blue-600 rounded-lg shadow-sm hover:bg-blue-700"
        >
          Print
        </Button>
      </div>
    </div>
  </div>
);

const StockDetailsPage = ({ setView, context, refreshOrders, user }) => {
  const [printContent, setPrintContent] = useState("");
  const [isOrderHeaderOpen, setIsOrderHeaderOpen] = useState(false);
  const [isOrderItemsOpen, setIsOrderItemsOpen] = useState(true);

  const [orderDetails, setOrderDetails] = useState(context?.stock || {});
  const [orderItems, setOrderItems] = useState(context?.items || []);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // ✅ Fetch from API if no items in context
  const refetchData = async () => {
    try {
      if (!context?.id) return;
      const data = await api.getselectedStock(context.id);
      setOrderDetails(data?.Table?.[0] || {});
      setOrderItems(data?.Table1 || []);
    } catch (err) {
      console.error("Error fetching stock details:", err);
      setError("Failed to fetch stock details.");
    }
  };

  useEffect(() => {
    if (!context?.items || context.items.length === 0) {
      refetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context?.id]);

  // Print handler
  const handlePrintInvoice = () => {
    const html = `
      <h2>Invoice #${orderDetails.DocNo || context?.id}</h2>
      <p>Customer: ${orderDetails.vname || orderDetails.Vname || ""}</p>
      <p>Date: ${orderDetails.podate || orderDetails.StockDate || ""}</p>
      <hr/>
      <ul>
        ${orderItems
          .map(
            (it) =>
              `<li>${it.ItemNo} - ${it.Qty} x ${it.Rate} = ${(
                it.Qty * it.Rate
              ).toFixed(2)}</li>`
          )
          .join("")}
      </ul>
    `;
    setPrintContent(html);
  };

  // Accordion UI section
  const AccordionSection = ({ title, isOpen, onToggle, children }) => (
    <div className="border border-gray-200 rounded-lg overflow-hidden mb-4">
      <div
        className="flex items-center justify-between p-4 bg-gray-100 cursor-pointer hover:bg-gray-200"
        onClick={onToggle}
      >
        <h2 className="text-lg font-medium text-gray-800">{title}</h2>
        <span>{isOpen ? "▲" : "▼"}</span>
      </div>
      {isOpen && <div className="p-4 bg-white">{children}</div>}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {printContent && (
        <PrintPreview
          htmlContent={printContent}
          onClose={() => setPrintContent("")}
        />
      )}

      {/* Header Bar */}
      <div className="p-4 bg-white shadow">
        <h1 className="mb-4 text-xl font-bold text-center text-gray-900">
          {`Stock Details #${context?.id}`}
        </h1>
      </div>

      {/* Error & Success Messages */}
      {error && (
        <div className="p-2 mx-auto my-2 text-red-700 bg-red-100 border border-red-300 rounded max-w-5xl">
          {error}
        </div>
      )}
      {success && (
        <div className="p-2 mx-auto my-2 text-green-700 bg-green-100 border border-green-300 rounded max-w-5xl">
          {success}
        </div>
      )}

      <div className="flex justify-center mt-6">
        <div className="w-full max-w-5xl p-4 sm:p-6 bg-white shadow-lg rounded-xl">
          {/* Stock Header */}
          <AccordionSection
            title="Stock Information"
            isOpen={isOrderHeaderOpen}
            onToggle={() => setIsOrderHeaderOpen(!isOrderHeaderOpen)}
          >
            <StockHeader
              orderDetails={orderDetails}
              user={user}
              setSuccess={setSuccess}
              setError={setError}
              setOrderDetails={setOrderDetails}
            />
          </AccordionSection>

          {/* Stock Items */}
          <AccordionSection
            title="Stock Items"
            isOpen={isOrderItemsOpen}
            onToggle={() => setIsOrderItemsOpen(!isOrderItemsOpen)}
          >
            <StockItems
              orderId={context?.id}
              stockId={orderDetails?.Vid}
              orderDate={orderDetails?.podate || orderDetails?.StockDate}
              items={orderItems}
              user={user}
              setError={setError}
              refetchData={refetchData}
            />
          </AccordionSection>

          {/* Actions */}
          <div className="flex justify-end gap-3 pt-4 mt-6 border-t">
            <Button
              onClick={() => {
                refreshOrders?.();
                setView("list");
              }}
              className="bg-pink-500 hover:bg-pink-600 px-4 py-2 text-white text-sm rounded"
            >
              Finish Order
            </Button>
            {/* Uncomment if you want Invoice Print */}
            {/* <Button
              onClick={handlePrintInvoice}
              className="bg-green-500 hover:bg-green-600 px-4 py-2 text-white text-sm rounded"
            >
              Invoice
            </Button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockDetailsPage;
